export default __webpack_public_path__ + "static/media/multisize.7e5c2640.svg";